module.exports = __webpack_public_path__ + "static/media/brand-4.70733cf5.png";